import { render, staticRenderFns } from "./RMs.vue?vue&type=template&id=0ad91ecc"
import script from "./RMs.vue?vue&type=script&lang=js"
export * from "./RMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports